/**
 * Client-side preview of the branded LP email (mirrors workers/send-lp-email template).
 */

const escapeHtml = (str) =>
  String(str || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const textToHtml = (text) => {
  const escaped = escapeHtml(text).trim();
  if (!escaped) return '<p style="margin:0 0 16px;color:#4a5568;">&nbsp;</p>';
  return escaped
    .split(/\n{2,}/)
    .map((block) => {
      const lines = block.split('\n').join('<br />');
      return `<p style="margin:0 0 16px;color:#2d3748;font-size:15px;line-height:1.65;">${lines}</p>`;
    })
    .join('');
};

export const buildEmailPreviewHtml = ({
  subject,
  body,
  recipientName = 'Investor',
  portalUrl,
}) => {
  const safeName = escapeHtml(recipientName);
  const safeSubject = escapeHtml(subject || 'Subject');
  const portal = escapeHtml((portalUrl || window.location.origin).replace(/\/$/, ''));
  const bodyHtml = textToHtml(body);

  return `<!DOCTYPE html>
<html lang="en">
<head><meta charset="utf-8" /><title>${safeSubject}</title></head>
<body style="margin:0;padding:0;background:#f5f6f8;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background:#f5f6f8;padding:32px 16px;">
    <tr><td align="center">
      <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="max-width:560px;background:#ffffff;border-radius:10px;overflow:hidden;border:1px solid #e2e6eb;">
        <tr><td style="background:#4f6478;padding:28px 32px;">
          <p style="margin:0;font-size:11px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;color:rgba(255,255,255,0.72);">RGNR Capital Partners</p>
          <h1 style="margin:8px 0 0;font-size:20px;font-weight:700;color:#ffffff;line-height:1.3;">${safeSubject}</h1>
        </td></tr>
        <tr><td style="padding:32px;">
          <p style="margin:0 0 20px;color:#69727e;font-size:14px;">Dear ${safeName},</p>
          ${bodyHtml}
          <table role="presentation" cellspacing="0" cellpadding="0" style="margin:28px 0 8px;">
            <tr><td style="border-radius:7px;background:#4f6478;">
              <a href="${portal}/letters" style="display:inline-block;padding:12px 22px;font-size:14px;font-weight:600;color:#ffffff;text-decoration:none;">View investor portal</a>
            </td></tr>
          </table>
        </td></tr>
        <tr><td style="padding:20px 32px 28px;border-top:1px solid #e2e6eb;background:#f9fafb;">
          <p style="margin:0 0 8px;font-size:12px;color:#98a1ac;line-height:1.5;">This message was sent by RGNR Capital Partners to authorized investors.</p>
          <p style="margin:0;font-size:12px;color:#98a1ac;"><a href="${portal}" style="color:#4f6478;">${portal}</a></p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body></html>`;
};
